module.exports = __webpack_public_path__ + "fonts/effect-remember-me-870ce5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-remember-me.svg
// module id = 817
// module chunks = 0